import type { components } from '@pba/types-openapi-client';
import { parseISO } from 'date-fns';
import { type UploadedFile, createUploadedFile } from '../uploaded-file';

export type ProgramSlim = {
  coverPhoto?: UploadedFile;
  endTime: Date;
  id: string;
  membersCount: number;
  name: string;
  price?: string;
  priceOption: 'contact_us' | 'free' | 'paid';
  profilePhoto?: UploadedFile;
  sponsors: Sponsor[];
  startTime: Date;
};

type Sponsor = {
  price?: string;
};

export const createProgramSlim = (data: components['schemas']['ProgramSlim']): ProgramSlim => ({
  coverPhoto: data.cover_photo ? createUploadedFile(data.cover_photo) : undefined,
  endTime: parseISO(data.end_time),
  id: data.id,
  membersCount: data.members_count,
  name: data.name,
  price: data.price,
  priceOption: data.price_option,
  profilePhoto: data.profile_photo ? createUploadedFile(data.profile_photo) : undefined,
  sponsors: data.sponsors.map((sponsor) => ({
    price: sponsor.price,
  })),
  startTime: parseISO(data.start_time),
});
